// extracted by mini-css-extract-plugin
export default {"workContainer":"Work_workContainer__JmSS9","tabList":"Work_tabList__Z8doo","tab":"Work_tab__tsuWY","active":"Work_active__YrtV7","tabPanel":"Work_tabPanel__T0Yj+"};